import { CALL_API } from '../middleware/api'
import {
  DEFAULT_CURRENCY,
  normalizeCurrency,
  readStoredOverride,
  readStoredDefault,
  clearStoredOverride,
} from '../utils/currency'

export const CURRENCY_INIT = 'CURRENCY_INIT'
export const CURRENCY_SET = 'CURRENCY_SET'
export const CURRENCY_DEFAULT_REQUEST = 'CURRENCY_DEFAULT_REQUEST'
export const CURRENCY_DEFAULT_SUCCESS = 'CURRENCY_DEFAULT_SUCCESS'
export const CURRENCY_DEFAULT_FAILURE = 'CURRENCY_DEFAULT_FAILURE'

/** Elección manual del usuario desde la barra superior. */
export function setCurrency(code) {
  return { type: CURRENCY_SET, code: normalizeCurrency(code) || DEFAULT_CURRENCY }
}

/** GET /customers/me/currency -> { Currency, Source } (EUR para ADMIN). */
export function fetchDefaultCurrency() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'customers/me/currency',
      authenticated: true,
      types: [CURRENCY_DEFAULT_REQUEST, CURRENCY_DEFAULT_SUCCESS, CURRENCY_DEFAULT_FAILURE],
    },
  }
}

/**
 * Arranque de la divisa tras AUTH_LOGIN_SUCCESS (lo dispara store/index.js).
 *  - fresh=true (login real): se descarta la elección manual previa para que el
 *    usuario "entre" con la divisa configurada en su ficha de cliente.
 *  - fresh=false (sesión restaurada de localStorage): se respeta la elección
 *    manual si existe.
 * Mientras llega la respuesta del API se usa la última divisa por defecto
 * cacheada para ese usuario, así los clientes en CZK/USD no ven un parpadeo
 * en EUR en cada recarga.
 */
export function initCurrency(authId, role, fresh) {
  return (dispatch) => {
    if (fresh) clearStoredOverride(authId)
    const override = fresh ? '' : readStoredOverride(authId)
    const cachedDefault = readStoredDefault(authId) || DEFAULT_CURRENCY
    dispatch({
      type: CURRENCY_INIT,
      authId,
      code: override || cachedDefault,
      defaultCode: cachedDefault,
      source: override ? 'user' : 'default',
    })
    if (role === 'CUSTOMER') {
      return dispatch(fetchDefaultCurrency())
    }
    return undefined
  }
}
